import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import PageNotFound from '../../assets/404.svg';

const NotFoundPage = () => (
  <Container maxWidth='md' className='page-error_wrapper'>
    <Grid className='page-error_grid'>
      <Grid className='page-error_content'>
        <h2 className='page-error_heading'>Page Not Found</h2>
        <Typography variant='subtitle1' className='page-error_message'>
          We can&apos;t find the page that you are looking for :(
        </Typography>
      </Grid>

      <Grid className='page-error-grid'>
        <img
          src={PageNotFound}
          alt='Page not found'
          className='page-error-grid__img'
        />
      </Grid>
    </Grid>
  </Container>
);

export default NotFoundPage;
